import {
  GET_CONTACTS_START,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAILED,
  BLOCK_CONTACTS_START,
  BLOCK_CONTACTS_FAIL,
  BLOCK_CONTACTS_SUCCESS,
  DELETE_CONTACTS_START,
  DELETE_CONTACTS_SUCCESS,
  DELETE_CONTACTS_FAIL,
  SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE,
  EMPTY_CONTACTS_LIST,
  NEW_CONTACTS_SUCCESS,
} from "./constants";

import {
  blockCustomerStart,
  blockCustomerSuccess,
  blockCustomerFail,
  deleteCustomerStart,
  deleteCustomerSuccess,
  deleteCustomerFail,
} from "./helper";

const initalState = {
  contacts: [],
  holidays: [],
  error: {
    type: "",
    message: "",
  },
  loading: false,
  errorMsg: "",
  showCustomerDetailsInContactPage: false,
};

const contactsReducer = (state = initalState, action) => {
  const { type, payload, error, showCustomerDetailsInContactPage } = action;
  switch (type) {
    case GET_CONTACTS_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_CONTACTS_SUCCESS: {
      // console.log("payloa ====================+>", payload);
      return {
        ...state,
        contacts: payload.contacts,
        holidays: payload.holidays,
        loading: false,
      };
    }
    case GET_CONTACTS_FAILED: {
      return {
        ...state,
        error,
        loading: false,
      };
    }
    case NEW_CONTACTS_SUCCESS: {
      return {
        ...state,
        contacts: [
          ...new Map(
            state.contacts.concat(payload.contacts).map((item) => [item["_id"], item]),
          ).values(),
        ],
        loading: false,
      };
    }
    case SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE:
      return { ...state, showCustomerDetailsInContactPage };
    case EMPTY_CONTACTS_LIST:
      return { ...state, contacts: [], holidays: [], error: { type: "", message: "" } };
    case BLOCK_CONTACTS_START:
      return blockCustomerStart(state, action);
    case BLOCK_CONTACTS_SUCCESS:
      return blockCustomerSuccess(state, action);
    case BLOCK_CONTACTS_FAIL:
      return blockCustomerFail(state, action);
    case DELETE_CONTACTS_START:
      return deleteCustomerStart(state, action);
    case DELETE_CONTACTS_SUCCESS:
      return deleteCustomerSuccess(state, action);
    case DELETE_CONTACTS_FAIL:
      return deleteCustomerFail(state, action);

    default:
      return state;
  }
};

export default contactsReducer;
